import { render } from "./AdminBackoffice.vue?vue&type=template&id=529bfd26"
import script from "./AdminBackoffice.vue?vue&type=script&lang=js"
export * from "./AdminBackoffice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__